import { atom, atomFamily, selector } from "recoil";
import { Matrix, MetaMatrix } from "./Matrix";
export var MouseButtonAtom = atom({
    key: "MouseButton",
    default: "none"
});
export var MetaMatrixAtom = atom({
    key: "MetaMatrix",
    default: new MetaMatrix(0, 0)
});
export var BoardCellAtomFamily = atomFamily({
    key: "BoardCellAtomFamily",
    default: function () { return 'empty'; }
});
export var CurrentBoardAtom = atom({
    key: "CurrentBoard",
    default: selector({
        key: "Selector/CurrentBoard",
        get: function (_a) {
            var get = _a.get;
            return Matrix.init(get(MetaMatrixAtom), 'empty');
        }
    })
});
export var WorkingBoardAtom = atom({
    key: "WorkingBoard",
    default: selector({
        key: "Selector/WorkingBoard",
        get: function (_a) {
            var get = _a.get;
            return Matrix.init(get(MetaMatrixAtom), 'empty');
        }
    })
});
export var HistoryAtom = atom({
    key: "History",
    default: []
});
export var HistoryStepNumberAtom = atom({
    key: "HistoryStepNumber",
    default: 0
});
export var GoalHintsAtom = atom({
    key: "GoalHints",
    default: {
        rows: [],
        cols: []
    }
});
export var CrossoutsAtom = atom({
    key: "CurrentHints",
    default: new Map()
});
export var IsGridHiddenAtom = atom({
    key: "IsGridHidden",
    default: false
});
